/**
 * How a real `Campaign` (§9) reads as a flat row — shared by the Campaigns
 * screen and the overview panel on `ReportsPage`, same reasoning `leadShape.js`
 * gives for leads: one mapping, not two screens quietly drifting apart.
 */

/** `crm.campaign.status` CHECK — copied, not re-derived, same as every other module's constants. */
export const CAMPAIGN_STATUS = ['planned', 'active', 'paused', 'completed', 'cancelled'];

export const STATUS_LABEL = {
  planned: 'Planned', active: 'Active', paused: 'Paused', completed: 'Completed', cancelled: 'Cancelled',
};

export const STATUS_TONE = {
  planned: 'sky', active: 'emerald', paused: 'amber', completed: 'neutral', cancelled: 'rose',
};

/**
 * `roi_pct` is a live-computed percentage return, not the small "3.4×"
 * multiplier the screen showed before this was a real endpoint — `null`
 * means no spend recorded yet, not a 0% return, and reads as "—".
 */
export function roiLabel(roiPct) {
  if (roiPct == null) return '—';
  return `${roiPct > 0 ? '+' : ''}${roiPct.toFixed(1)}%`;
}

export function toRow(c) {
  return {
    id: c.id,
    code: c.code,
    name: c.name,
    type: c.campaign_type?.name ?? null,
    status: c.status,
    statusLabel: STATUS_LABEL[c.status] ?? c.status,
    statusTone: STATUS_TONE[c.status] ?? 'neutral',
    startDate: c.start_date,
    endDate: c.end_date,
    budget: c.budget,
    spent: c.actual_cost,
    currency: c.currency,
    owner: c.owner?.full_name ?? null,
    members: c.performance?.members ?? 0,
    leads: c.performance?.leads_created ?? 0,
    converted: c.performance?.leads_converted ?? 0,
    opportunities: c.performance?.opportunities ?? 0,
    pipelineValue: c.performance?.pipeline_value ?? 0,
    wonValue: c.performance?.won_value ?? 0,
    roiPct: c.performance?.roi_pct ?? null,
    costPerLead: c.performance?.cost_per_lead ?? null,
    rowVersion: c.row_version,
    raw: c,
  };
}
